document.addEventListener("DOMContentLoaded", function () {
    const variantSelector = document.querySelector("select[name='id']");
    if (!variantSelector) return;

    variantSelector.addEventListener("change", function () {
        const selectedVariantId = this.value;
        fetch(window.location.pathname + `.json`)
            .then((res) => res.json())
            .then((data) => {
                const selectedVariant = data.product.variants.find(
                    (v) => v.id == selectedVariantId
                );

                if (selectedVariant && selectedVariant.metafields.custom.variant_images) {
                    const variantImages = selectedVariant.metafields.custom.variant_images;
                    updateProductImages(variantImages);
                }
            });
    });

    function updateProductImages(variantImages) {
        const gallery = document.querySelector(".product__media-list");
        if (!gallery) return;

        gallery.innerHTML = ""; // Clear existing images

        variantImages.forEach((imageSrc) => {
            const li = document.createElement("li");
            li.className = "product__media-item";
            li.innerHTML = `<img src="${imageSrc}" alt="Variant Image">`;
            gallery.appendChild(li);
        });
    }
});
